export const NEWBUILDINGS_GENPLAN_IN_CARD = 'newbuildings-genplan-in-card';

export const EXPERIMENTS = [NEWBUILDINGS_GENPLAN_IN_CARD];
